import { cookieExists, setCookie, deleteCookie } from './cookieHelper';
import { getDeviceType } from './deviceDetection';
import { TUTORIAL_CONTENT } from '@/data/tutorial';
import { ModalId, ModalCheckResult } from '@/lib/types/tutorial';


function getCookieName(modalId: ModalId, userId?: string): string {
  const deviceType = getDeviceType();
  const userSuffix = userId ? `_${userId}` : '_guest';
  return `tutorial_${modalId}_${deviceType}${userSuffix}`;
}

/**
 * @param modalId 
 * @param userId 
 */
export function shouldShowModal(modalId: ModalId, userId?: string): ModalCheckResult {
  const cookieName = getCookieName(modalId, userId);
  
  if (!cookieExists(cookieName)) {
    return {
      shouldShow: true,
      content: TUTORIAL_CONTENT[modalId] || null
    };
  }
  
  return {
    shouldShow: false,
    content: null
  };
}

/**
 * @param modalId
 * @param userId
 */
export function markModalAsShown(modalId: ModalId, userId?: string): void {
  const cookieName = getCookieName(modalId, userId);
  const twoWeeksInDays = 14;
  
  setCookie(cookieName, 'shown', twoWeeksInDays);
}

/* Reset a specific modal (delete its cookie) */
export function resetModal(modalId: ModalId): void {
  const cookieName = getCookieName(modalId);
  deleteCookie(cookieName);
}

/**
 * Reset all modals for a feature
 * @param feature 
 */
export function resetFeatureModals(feature: 'buy_for_me' | 'ship' | 'store' | 'wallet'): void {
  const featureModals = (Object.keys(TUTORIAL_CONTENT) as ModalId[]).filter(
    key => TUTORIAL_CONTENT[key].feature === feature
  );
  
  featureModals.forEach(modalId => resetModal(modalId));
}